import { render, staticRenderFns } from "./HomeSustain.vue?vue&type=template&id=76aa3aca&scoped=true"
import script from "./HomeSustain.vue?vue&type=script&lang=js"
export * from "./HomeSustain.vue?vue&type=script&lang=js"
import style0 from "./HomeSustain.vue?vue&type=style&index=0&id=76aa3aca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76aa3aca",
  null
  
)

export default component.exports